import { render, staticRenderFns } from "./CartNavigation.vue?vue&type=template&id=8fab9eaa&"
import script from "./CartNavigation.vue?vue&type=script&lang=js&"
export * from "./CartNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CartNavigation.vue?vue&type=style&index=0&id=8fab9eaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports